import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Navigate, useSearchParams, useLocation } from 'react-router-dom';
import { ROUTE_PATH, ROUTE_STARTUP_PATH } from 'routes';
import LoginForm from './LoginForm';
import RecoveryForm from './RecoveryForm';
import 'routes/Auth/styles.scss';

function Login({
  platform,
  literals,
  literalsCommon,
  isAuthenticated,
  onLogin,
  onRecovery,
  cleanErrors,
}) {
  const [showRecoveryForm, setShowRecoveryForm] = useState(false);
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const inviteFundraise = searchParams.get('inviteFundraise');
  const referral = searchParams.get('referral');
  const startup = searchParams.get('startup');
  const external = searchParams.get('external');

  if (isAuthenticated) {
    let redirectTo = ROUTE_PATH.PREHOME;
    let search = '';

    if (startup) {
      redirectTo = external || startup.length
        ? ROUTE_STARTUP_PATH.ONBOARDING
        : ROUTE_STARTUP_PATH.setHome(startup);
      search = `?startup=${startup}${external ? '&external=1' : ''}`;
    } else if (location.state && ![ROUTE_PATH.BASEROUTE, ROUTE_PATH.LOGOUT].includes(location.state.from)) {
      redirectTo = location.state.from;
      // eslint-disable-next-line no-nested-ternary
      search = inviteFundraise ? `?invite=${inviteFundraise}` : referral ? `?referral=${referral}` : '';
    }

    return <Navigate to={{ pathname: redirectTo, state: location.state, search }} />;
  }

  if (showRecoveryForm) {
    return (
      <RecoveryForm
        literals={literals}
        literalsCommon={literalsCommon}
        onRecovery={onRecovery}
        onBack={() => {
          setShowRecoveryForm(false);
          cleanErrors();
        }}
      />
    );
  }

  return (
    <LoginForm
      literals={literals}
      literalsCommon={literalsCommon}
      platform={platform}
      onLogin={onLogin}
      cleanErrors={cleanErrors}
      setShowRecoveryForm={setShowRecoveryForm}
    />
  );
}

Login.propTypes = {
  platform: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  literals: PropTypes.object.isRequired,
  literalsCommon: PropTypes.object.isRequired,
  onLogin: PropTypes.func.isRequired,
  onRecovery: PropTypes.func.isRequired,
  cleanErrors: PropTypes.func.isRequired,
};

export default Login;
